import React from 'react';
import { ArrowUpRight, Target, LineChart, Users } from 'lucide-react';

const GetReview = () => {
   const sections = [
       {
           title: "Enhance Leadership Impact",
           description: "Assessing Executive Presence helps leaders refine how they influence, communicate, and inspire, ensuring they leave a lasting impression on their teams and stakeholders.",
           icon: <Users className="w-8 h-8 text-blue-500" />
       },
       {
           title: "Identify Growth Areas",
           description: "By evaluating their presence, leaders can pinpoint key areas for development, enabling them to project confidence, decisiveness, and authority in critical situations.",
           icon: <Target className="w-8 h-8 text-blue-500" />
       },
       {
           title: "Boost Organizational Success",
           description: "Strengthening Executive Presence not only enhances personal credibility but also fosters alignment and collaboration, driving overall team and organizational success.",
           icon: <LineChart className="w-8 h-8 text-blue-500" />
       }
   ];

    return (
        <div data-aos="fade-up" className="lg:px-16 p-4 bg-gradient-to-r from-gray-100 to-white">
            <div className="space-y-6">
                <div className="w-full lg:text-justify  ">
                    <h1 style={{ fontFamily: "Helvetica", fontSize:"30px" }}  className="text-4xl font-bold text-gray-900 mb-6">
                        Why should leaders assess their Executive Presence?
                    </h1>
                    <p  style={{ fontFamily: "Poppins" }}  className="text-xl text-gray-700 leading-relaxed  mb-8">
                        Assessing Executive Presence is essential for leaders striving to make a powerful and lasting impact. Here are three key reasons why leaders should evaluate and strengthen this critical attribute:
                    </p>
                </div>
     
                <div data-aos="fade-up" className="grid md:grid-cols-3 gap-8">
                    {sections.map((section, index) => (
                        <div key={index} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100">
                            <div className="flex items-center gap-4 mb-4">
                                {section.icon}
                                <h2  style={{ fontFamily: "Helvetica" }}  className="text-xl font-bold text-gray-900">{section.title}</h2>
                            </div>
                            <p  style={{ fontFamily: "Poppins" }}  className="text-gray-700 text-justify leading-relaxed">
                                {section.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
     );
}

export default GetReview;